const getPinSVG = (fill, stroke) => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('fill', 'none');
    /** we should use a class instead of setting styles here */
    svg.style.width = '42';
    svg.style.height = '46';
    svg.style.stroke = stroke;
    svg.style.fill = fill;
    svg.setAttribute('viewBox', '0 0 42 46');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 
    // eslint-disable-next-line max-len
    'M20.7911 45.8571L20.5607 45.5044C20.5607 45.5044 20.5608 45.5043 20.5608 45.5043L20.7911 45.8571ZM20.5427 45.4767C20.5427 45.4767 20.5426 45.4767 20.5426 45.4767L20.5177 45.4385L20.4861 45.4591C20.3991 45.43 20.2768 45.3808 20.115 45.3027C19.583 45.046 18.7968 44.5639 17.8302 43.884C15.9039 42.5293 13.3252 40.435 10.744 37.9272C8.1618 35.4186 5.59088 32.5096 3.66891 29.527C1.74099 26.5352 0.5 23.5214 0.5 20.7911C0.5 9.58465 9.58465 0.5 20.7911 0.5C31.9976 0.5 41.0823 9.58465 41.0823 20.7911C41.0823 23.5178 39.844 26.4201 37.9192 29.2722C35.9994 32.1169 33.4303 34.8621 30.8463 37.2638C28.2644 39.6636 25.6805 41.7087 23.7409 43.1544C22.7716 43.8769 21.9642 44.449 21.3998 44.84C21.1176 45.0355 20.8962 45.1856 20.7458 45.2867C20.6706 45.3372 20.6132 45.3754 20.5747 45.4009L20.5314 45.4294L20.5208 45.4364L20.5183 45.4381L20.5177 45.4384L20.5427 45.4767ZM20.6311 45.4946C20.6313 45.4948 20.629 45.4948 20.6237 45.4942C20.6283 45.4942 20.6308 45.4945 20.6311 45.4946Z');
    svg.appendChild(path);
    return svg;
};
const getMarkerState = (properties) => {
    const { highlight, selected } = properties;
    if (selected)
        return 'selected';
    if (highlight)
        return 'hovered';
    return 'default';
};
const getPricePinSVG = (properties) => {
    const { marker } = properties;
    if (!marker)
        throw Error('Unexpected missing marker property');
    const { markerStyle } = marker;
    const markerState = getMarkerState(properties);
    const fillColorsByMarkerStyle = {
        price: {
            default: 'currentColor',
            hovered: 'var(--brand-map-pin-price-fill-card-hovered)',
            selected: 'var(--brand-map-pin-price-lab-selected)',
        },
        you: {
            default: 'var(--brand-map-pin-you-color)',
            hovered: 'var(--brand-map-pin-you-color)',
            selected: 'var(--brand-map-pin-you-color)',
        },
    };
    const fillColor = fillColorsByMarkerStyle[markerStyle][markerState];
    const strokeColorsByMarkerStyle = {
        price: {
            default: 'var(--brand-map-pin-price-stroke)',
            hovered: 'var(--brand-map-pin-price-stroke)',
            selected: 'var(--brand-map-pin-price-stroke)',
        },
        you: {
            default: 'var(--brand-map-pin-you-color)',
            hovered: 'var(--brand-map-pin-you-color)',
            selected: 'var(--brand-map-pin-you-color)',
        },
    };
    const strokeColor = strokeColorsByMarkerStyle[markerStyle][markerState];
    return getPinSVG(fillColor, strokeColor);
};

export { getPricePinSVG };
